module.exports = __webpack_public_path__ + "static/img/dz7.0a518d31.png";